import {CardContent} from '../card';
import React from 'react';
import {ITableProps} from '../table';
import Table from '../table/table';

export interface ITemplatePlainTextCardProps {
    text: ITableProps;
}

const PlainTextCard = (props: ITemplatePlainTextCardProps): JSX.Element => (
    <CardContent>
        <div className="text text--double">
            <Table {...props.text} />
        </div>
    </CardContent>

);

export default PlainTextCard;
